import _jsx from "@babel/runtime/helpers/jsx";
var _ModalTitle;
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import querystring from 'querystring';
import { sendClick, sendImpressions } from 'reaxl-analytics';
import { dealerRatingClick, dealerRatingImpressions } from 'reaxl-analytics-handlers';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import { Button, Modal, ModalHeader, ModalTitle } from 'reaxl';
import IframeKBBDealerRatings from '../IframeKBBDealerRatings';
import KBBInlineRatings from '../KBBInlineRatings';
const DEPRECATED_TYPES = ['stacked', 'large'];

/**
 *  Displays KBB dealer ratings
 *
 */
function KBBDealerRatings(_ref) {
  let {
    enableImpression = false,
    enableClick = true,
    className,
    owner,
    showCount = false,
    widgetType = 'inline',
    defaultShowModal = false,
    onToggleModal,
    ...rest
  } = _ref;
  const pageName = useSelector(state => _get(state, 'currentPageName', ''));

  // TODO: removing VDP logic would be breaking change now, but should u/d FYC to
  // only pass enableImpression from VDP, then simplify this.
  // DEPRECATE most of impression logic
  if (pageName !== 'vdp' || DEPRECATED_TYPES.includes(widgetType)) {
    enableImpression = false;
  }
  const [showModal, setShowModal] = useState(defaultShowModal);
  const {
    id,
    rating: {
      count,
      value,
      apiKey,
      apiUrl
    } = {}
  } = owner ?? {};
  useEffect(() => {
    if (enableImpression && value) {
      sendImpressions({
        name: dealerRatingImpressions,
        data: {
          id
        }
      });
    }
  }, [value, id, pageName, enableImpression, widgetType]);

  // Deprecate the iframe widgets
  if (DEPRECATED_TYPES.includes(widgetType)) {
    // eslint-disable-next-line no-console
    console.log(`${widgetType} is deprecated. Please use the IframeKBBDealerRatings component`);
    return /*#__PURE__*/React.createElement(IframeKBBDealerRatings, Object.assign({
      owner: owner,
      widgetType: widgetType,
      className: className
    }, rest));
  }
  const params = {
    apiKey,
    svocId: id,
    nocount: showCount
  };
  const urlParams = querystring.stringify(params);
  const toggleModal = event => {
    if (typeof onToggleModal === 'function') {
      try {
        onToggleModal(event);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }
    if (!showModal && enableClick) {
      sendClick(dealerRatingClick, event, {
        ratingSource: 'kbb',
        value,
        count,
        id
      });
    }
    setShowModal(!showModal);
  };
  const modalSrc = `${apiUrl}/v2/widget/ratings/overlay?` + urlParams;
  return /*#__PURE__*/_jsx(React.Fragment, {}, "kbbDealerRatings", widgetType === 'link' && /*#__PURE__*/_jsx(Button, {
    className: className,
    onClick: toggleModal,
    bsStyle: "text"
  }, void 0, "Learn More"), widgetType === 'inline' && !!value && /*#__PURE__*/_jsx(KBBInlineRatings, {
    rating: value,
    count: showCount ? count : undefined,
    handleCountClick: toggleModal,
    className: className,
    label: "Dealer"
  }), showModal && /*#__PURE__*/_jsx(Modal, {
    show: showModal,
    onHide: toggleModal
  }, void 0, /*#__PURE__*/_jsx(ModalHeader, {
    closeButton: true
  }, void 0, _ModalTitle || (_ModalTitle = /*#__PURE__*/_jsx(ModalTitle, {
    className: "sr-only"
  }, void 0, "KBB.com Dealer Rating")), /*#__PURE__*/React.createElement("iframe", Object.assign({
    id: "kdr-popup-content",
    "data-cmp": "kbbDealerRatings",
    width: "100%",
    height: 500,
    title: "KBB.com Dealer Rating Details",
    className: "border-0",
    src: modalSrc
  }, rest, {
    key: "kdr-popup-content"
  })))));
}
export default KBBDealerRatings;